import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { notify } from 'react-notify-toast'
import teacherLogo from '../../assets/img/teacher.jpg'
import institutionLogo from '../../assets/img/institution.jpg'
import childcareCentreLogo from '../../assets/img/childcare_centre.jpg'
import './Register.css'
import { Item } from 'semantic-ui-react'

import SignupContainer from '../Signup-Login/SignupContainer'
import LinkToCreateAccount from '../Signup-Login/LinkToCreateAccount'
import SignUpCollegePopUp from '../../Components/PopUpForm/SignUpCollege-Popup'

const RegisterOption = (props) => {
  const [showPopup, setShowPopup] = useState(false)

  const showConfirmCollegePopUp = () => {
    setShowPopup(true);
  };

  const hideConfirmCollegePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (props.location.state) {
      if (props.location.state.error) {
        notify.show(props.location.state.error, 'error', 3000)
      }
    }
    window.localStorage.removeItem('isShowECECTeacherModal')
  }, [])

  function setTeacher(e) {
    e.preventDefault();
    window.localStorage.setItem('userType', 'teacherLogin')
    props.history.push("/TeacherOption");
  }

  function setProvider(e, isChildcareCentre) {
    e.preventDefault();
    window.localStorage.setItem('userType', 'institutionLogin')
    window.localStorage.setItem('isChildcareCentre', isChildcareCentre)
    showConfirmCollegePopUp()
  }

  return (
    <SignupContainer
      heading="Welcome to ReadyTeacher"
      subheading="Australia & New Zealand"
    >
      <div className="row justify-content-center">
        <div className="vice-tittle-for-register-option">
          Which of these best describes you?
        </div>
      </div>

      <div className="row justify-content-center register-option-content">
        <Item.Group>
          <Item className="register-option-teacher-item">
            <Link
              to="/TeacherOption"
              className="link-to-register"
              onClick={setTeacher}
            >
              <Item.Image
                // size="tiny"
                src={teacherLogo}
                className="register-option-img"
              />
              {/* https://react.semantic-ui.com/images/wireframe/image.png */}
              <Item.Content className="register-option-item-content">
                <Item.Header>I'm a Teacher or Educator</Item.Header>
                <Item.Meta>Get access to teaching opportunities</Item.Meta>
              </Item.Content>
            </Link>
          </Item>
          {/* <Item className = {(process.env.NODE_ENV === "production")
                              ? "isDisabled register-option-institute-item "
                              : "register-option-institute-item "}> */}

          <Item className="register-option-institute-item ">
            <Link
              to="/RegisterCollege"
              className="link-to-register"
              onClick={(e) => setProvider(e, "no")}
            >
              <Item.Image
                // size="tiny"
                src={institutionLogo}
                className="register-option-img"
              />
              <Item.Content className="register-option-item-content">
                <Item.Header>
                  I manage an ELICOS centre or VET college
                </Item.Header>
              </Item.Content>
            </Link>
          </Item>

          <Item className="register-option-institute-item isDisabled">
            <div className="link-to-register">
              <Item.Image
                src={childcareCentreLogo}
                className="register-option-img register-childcare-option-img"
              />
              <Item.Content className="register-option-item-content">
                <Item.Header>
                  I manage a childcare or early learning centre (ECEC)
                </Item.Header>
              </Item.Content>
            </div>
          </Item>
        </Item.Group>
      </div>

      <SignUpCollegePopUp
        show={showPopup}
        onClose={() => {
          hideConfirmCollegePopup();
        }}
        onAnswerYes={() => {
          hideConfirmCollegePopup();
          window.localStorage.setItem('isShowECECTeacherModal', 'true')
          props.history.push("/TeacherOption")
        }}
        onAnswerNo={() => {
          hideConfirmCollegePopup();
          props.history.push("/RegisterCollege")
        }}
      />

      {/* go to login if user has an account */}
      <LinkToCreateAccount onRegister={true} />
    </SignupContainer>
  )
}

export default RegisterOption
